import { BigNumber, ethers } from "ethers";

export const convertBigNumber = (_number, baseNumber, fractionDigits) => {
  if (baseNumber <= 1) return BigNumber.from(_number).toNumber();
  else {
    let _base = null;
    let _fractionDigits = null;
    if (baseNumber <= fractionDigits) {
      _base = BigNumber.from(10).pow(baseNumber);
      _fractionDigits = baseNumber;
    } else {
      _base = BigNumber.from(10).pow(baseNumber - fractionDigits);
      _fractionDigits = fractionDigits;
    }
    return parseFloat(ethers.utils.formatUnits(BigNumber.from(_number).div(_base), _fractionDigits));
  }
};
